export function entityFieldSubscriber(entity, field, subscriber) {
    const valueHolder = {
        previousValue: entity.get(field),
        isLocal: false,
    };
    function handler(info) {
        if (entity.deleted) {
            return;
        }
        const newValue = entity.get(field);
        if (newValue !== this.previousValue) {
            this.isLocal = info.isLocal;
            subscriber(newValue, this);
            this.previousValue = newValue;
        }
    }
    return entity.subscribe('change', handler.bind(valueHolder));
}
//# sourceMappingURL=entityFieldSubscriber.js.map